import { render, staticRenderFns } from "./index.vue?vue&type=template&id=befd29ca"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mining-sale-cms-front/mining-sale-cms-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('befd29ca')) {
      api.createRecord('befd29ca', component.options)
    } else {
      api.reload('befd29ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=befd29ca", function () {
      api.rerender('befd29ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RuoYi/clearCache/index.vue"
export default component.exports